class blockBannerPromo extends HTMLElement {
  constructor() {
    super();
    this.countBanner = this.getAttribute('data-count-banner');
    this.statusEnableSlider = this.getAttribute('data-enable-mb');
    // if (this.countBanner > 3) {
    //   this.countBanner = 3;
    // }
    this.sectionId = this.getAttribute('data-section-id');
    this.renderSlider();
  }

  renderSlider() {
    let sectionId = this.sectionId;
    let countSlider = this.countBanner;
    let countMobile = 1;

    const isLarge = countSlider > 3;
    const slidesPerViewValue = isLarge ? 'auto' : countSlider;
    const centeredSlidesValue = isLarge;
    const loopValue = isLarge;

    if (this.statusEnableSlider == 'true') {
      if (countSlider >= 2) {
        countMobile = 1.122;
      }
    } else {
      countMobile = countSlider > 3 ? 1.122 : countSlider;
    }

    new Swiper(`.swiper-block-banner-promo-${sectionId}`, {
      slidesPerView: countMobile,
      spaceBetween: 8,
      loop: false,
      centeredSlides: false,
      pagination: {
        el: `.swiper-pagination-${sectionId}`,
        clickable: true,
      },
      navigation: {
        nextEl: `.swiper-button-next-${sectionId}`,
        prevEl: `.swiper-button-prev-${sectionId}`,
      },
      breakpoints: {
        990: {
          slidesPerView: 'auto',
          centeredSlides: centeredSlidesValue,
          loop: loopValue,
        },
      },
    });
  }
}
customElements.define('block-banner-promo', blockBannerPromo);
